import { flattenValues } from '@uniformdev/canvas';
import { PricingCard } from 'src/libraries/design/components/pricing-card/src/pricing-card';
import { PricingCards } from 'src/libraries/design/patterns/pricing-cards/src/pricing-cards';

interface UniformPricePlanBenefitProps {
	label: string;
	details?: string;
}

interface UniformStaticPricingCardProps {
	title: string;
	price: string;
	unit?: string;
	buttonText: string;
	buttonHref: string;
	benefits?: UniformPricePlanBenefitProps[];
}

interface UniformStaticPricingCardsProps {
	staticPricingCards: UniformStaticPricingCardProps[];
}

const UniformStaticPricingCards = ({ staticPricingCards }: UniformStaticPricingCardsProps) => {
	const flattenedProps = flattenValues(
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		staticPricingCards as any,
	) as UniformStaticPricingCardProps[];
	return (
		<PricingCards>
			{flattenedProps.map((cardProps, index) => (
				<PricingCard key={index} {...cardProps} />
			))}
		</PricingCards>
	);
};

export default UniformStaticPricingCards;
